import type { SVGProps } from 'react';

interface IconProps extends SVGProps<SVGSVGElement> {
  size?: number | string;
}

export function PlayIcon({ size = 24, className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...props}
    >
      <path
        d="M22.5 11.9995C22.5006 12.2541 22.4353 12.5046 22.3105 12.7266C22.1856 12.9485 22.0055 13.1344 21.7875 13.2661L8.28 21.5292C8.05227 21.6686 7.79144 21.7448 7.52445 21.7497C7.25746 21.7546 6.99399 21.6882 6.76125 21.5573C6.53073 21.4284 6.3387 21.2404 6.2049 21.0127C6.07111 20.785 6.00039 20.5258 6 20.2617V3.7373C6.00039 3.4732 6.07111 3.21396 6.2049 2.98625C6.3387 2.75853 6.53073 2.57057 6.76125 2.44168C6.99399 2.31076 7.25746 2.24434 7.52445 2.24928C7.79144 2.25422 8.05227 2.33035 8.28 2.4698L21.7875 10.7329C22.0055 10.8646 22.1856 11.0505 22.3105 11.2724C22.4353 11.4944 22.5006 11.7448 22.5 11.9995Z"
        fill="currentColor"
      />
    </svg>
  );
}
